var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPluginSpaceTimeCubeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  fillRule: "evenodd",
  d: "M4 17.7a1.948 1.948 0 0 1-1-1.725v-7.95A1.95 1.95 0 0 1 4 6.3l7-4.025Q11.475 2 12 2t1 .275L20 6.3q.475.275.738.725.262.45.262 1v7.95a1.95 1.95 0 0 1-1 1.725l-7 4.025Q12.525 22 12 22t-1-.275z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  fillRule: "evenodd",
  d: "m5 9.1 6 3.475v6.85L5 15.95zm14 0v6.85l-6 3.475v-6.85zM12 4l5.925 3.425L12 10.85 6.075 7.425z"
}))));
export default SvgPluginSpaceTimeCubeIcon;